import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";
import { defaultListMessages } from "../shared/crud/list";
import { Message } from "../shared/i18n";
import {
  AccommodationSortingCriteria,
  BehaviourEntity,
  BundlingConfiguration,
  DepositCheckoutTextConfiguration,
  DepositNotRequiredTextConfiguration,
  DepositRequiredTextConfiguration,
  ExtrasTextConfiguration,
  InventoryGroupingCriteria,
  OccupationAlternatives,
  PendingAmountTextConfiguration,
  PriceCalendar,
  PromosConfig,
  RateType,
  RoomSelectionViewType,
  ShowExtrasConfiguration,
  ShowPromoCodeCriteria,
  SplitStay,
  TaxesText,
} from "./domain/behaviour.entity";

const formMessages: Omit<
  Record<keyof BehaviourEntity, Message>,
  "maxAccommodationsMultiReservationSection"
> = defineMessages({
  id: {
    id: "behaviourForm.label.accommodationsOrder",
    defaultMessage: "accommodationsOrder",
  },
  accommodationsOrder: {
    id: "behaviourForm.label.accommodationsOrder",
    defaultMessage: "accommodationsOrder",
  },
  addObligatoryExtrasRateToRoomSelection: {
    id: "behaviourForm.label.addObligatoryExtrasRateToRoomSelection",
    defaultMessage: "addObligatoryExtrasRateToRoomSelection",
  },
  showDecimalsInExtrasPage: {
    id: "behaviourForm.label.showDecimalsInExtrasPage",
    defaultMessage: "showDecimalsInExtrasPage",
  },
  isCancellationReasonRequired: {
    id: "behaviourForm.label.isCancellationReasonRequired",
    defaultMessage: "isCancellationReasonRequired",
  },
  depositNotRequiredTextConfiguration: {
    id: "behaviourForm.label.depositNotRequiredTextConfiguration",
    defaultMessage: "depositNotRequiredTextConfiguration",
  },
  depositRequiredTextConfiguration: {
    id: "behaviourForm.label.depositRequiredTextConfiguration",
    defaultMessage: "depositRequiredTextConfiguration",
  },
  enginePageTitle: {
    id: "behaviourForm.label.enginePageTitle",
    defaultMessage: "enginePageTitle",
  },
  hasRoomCombination: {
    id: "behaviourForm.label.hasRoomCombination",
    defaultMessage: "hasRoomCombination",
  },
  hideLocked: {
    id: "behaviourForm.label.hideLocked",
    defaultMessage: "hideLocked",
  },
  hideObligatoryExtras: {
    id: "behaviourForm.label.hideObligatoryExtras",
    defaultMessage: "hideObligatoryExtras",
  },
  hideRestricted: {
    id: "behaviourForm.label.hideRestricted",
    defaultMessage: "hideRestricted",
  },
  inventoryGroupingCriteria: {
    id: "behaviourForm.label.inventoryGroupingCriteria",
    defaultMessage: "Criterio de agrupación de líneas de inventario",
  },
  isLogoLinkingToPropertyUrl: {
    id: "behaviourForm.label.isLogoLinkingToPropertyUrl",
    defaultMessage: "isLogoLinkingToPropertyUrl",
  },
  maxRoomsInUnitSelector: {
    id: "behaviourForm.label.maxRoomsInUnitSelector",
    defaultMessage: "maxRoomsInUnitSelector",
  },
  pendingAmountTextConfiguration: {
    id: "behaviourForm.label.pendingAmountTextConfiguration",
    defaultMessage: "pendingAmountTextConfiguration",
  },
  priceCalendar: {
    id: "behaviourForm.label.priceCalendar",
    defaultMessage: "priceCalendar",
  },
  propertyUrl: {
    id: "behaviourForm.label.propertyUrl",
    defaultMessage: "propertyUrl",
  },
  roomSelectionViewType: {
    id: "behaviourForm.label.roomSelectionViewType",
    defaultMessage: "roomSelectionViewType efe",
  },
  roomsLeftAvailabilityLimit: {
    id: "behaviourForm.label.roomsLeftAvailabilityLimit",
    defaultMessage: "roomsLeftAvailabilityLimit",
  },
  showAllReservationsIds: {
    id: "behaviourForm.label.showAllReservationsIds",
    defaultMessage: "showAllReservationsIds",
  },
  showBestPriceGuaranteed: {
    id: "behaviourForm.label.showBestPriceGuaranteed",
    defaultMessage: "showBestPriceGuaranteed",
  },
  showBookingForm: {
    id: "behaviourForm.label.showBookingForm",
    defaultMessage: "Dates and occupancy form",
  },
  showCancelMsg: {
    id: "behaviourForm.label.showCancelMsg",
    defaultMessage: "showCancelMsg",
  },
  showCookiePolicy: {
    id: "behaviourForm.label.showCookiePolicy",
    defaultMessage: "showCookiePolicy",
  },
  showCurrencySelector: {
    id: "behaviourForm.label.showCurrencySelector",
    defaultMessage: "showCurrencySelector",
  },
  showDesktopLogo: {
    id: "behaviourForm.label.showDesktopLogo",
    defaultMessage: "showDesktopLogo",
  },
  showDiscountsCalculation: {
    id: "behaviourForm.label.showDiscountsCalculation",
    defaultMessage: "showDiscountsCalculation",
  },
  showExtrasConfiguration: {
    id: "behaviourForm.label.showExtrasConfiguration",
    defaultMessage: "showExtrasConfiguration",
  },
  showFullReservationIds: {
    id: "behaviourForm.label.showFullReservationIds",
    defaultMessage: "showFullReservationIds",
  },
  showInactiveDiscounts: {
    id: "behaviourForm.label.showInactiveDiscounts",
    defaultMessage: "showInactiveDiscounts",
  },
  showInventoryPriceDiff: {
    id: "behaviourForm.label.showInventoryPriceDiff",
    defaultMessage: "showInventoryPriceDiff",
  },
  showLanguageSelector: {
    id: "behaviourForm.label.showLanguageSelector",
    defaultMessage: "showLanguageSelector",
  },
  showMobileLogo: {
    id: "behaviourForm.label.showMobileLogo",
    defaultMessage: "showMobileLogo",
  },
  showMultipleAccommodations: {
    id: "behaviourForm.label.showMultipleAccommodations",
    defaultMessage: "showMultipleAccommodations",
  },
  maxAccommodationsMultiReservation: {
    id: "behaviourForm.label.maxAccommodationsMultiReservation",
    defaultMessage: "maxAccommodationsMultiReservation",
  },
  showOccupationAlternatives: {
    id: "behaviourForm.label.showOccupationAlternatives",
    defaultMessage: "showOccupationAlternatives",
  },
  splitStayConfiguration: {
    id: "behaviourForm.label.splitStayConfiguration",
    defaultMessage: "splitStayConfiguration",
  },
  showPromoCodeCriteria: {
    id: "behaviourForm.label.showPromoCodeCriteria",
    defaultMessage: "showPromoCodeCriteria",
  },
  showPromos: {
    id: "behaviourForm.label.showPromos",
    defaultMessage: "showPromos",
  },
  showRackRate: {
    id: "behaviourForm.label.showRackRate",
    defaultMessage: "showRackRate",
  },
  showRestrictedHighlightMessages: {
    id: "behaviourForm.label.showRestrictedHighlightMessages",
    defaultMessage: "showRestrictedHighlightMessages",
  },
  taxesText: {
    id: "behaviourForm.label.taxesText",
    defaultMessage: "taxesText",
  },
  unavailableURL: {
    id: "behaviourForm.label.unavailableURL",
    defaultMessage: "unavailableURL",
  },
  showElementsSection: {
    id: "behaviourForm.section.showElements",
    defaultMessage: "Show elements",
  },
  logoSection: {
    id: "behaviourForm.section.logoSection",
    defaultMessage: "Logo section",
  },
  textsSection: {
    id: "behaviourForm.section.textsSection",
    defaultMessage: "Texts section",
  },
  resultSection: {
    id: "behaviourForm.section.resultSection",
    defaultMessage: "Result section",
  },
  promosSections: {
    id: "behaviourForm.section.promosSections",
    defaultMessage: "Promos section",
  },
  otherParamsSection: {
    id: "behaviourForm.section.otherParamsSection",
    defaultMessage: "Other params section",
  },
  bundlingConfiguration: {
    id: "behaviourForm.section.bundlingConfiguration",
    defaultMessage: "Accommodation options in grouped accommodations for the selected occupancy",
  },
  waitingListEnabled: {
    id: "behaviourForm.label.waitingListEnabled",
    defaultMessage: "Waiting list",
  },
  showCheckoutButtonRoomUnits: {
    id: "behaviourForm.label.showCheckoutButtonRoomUnits",
    defaultMessage: "Show Checkout Button Room Units",
  },
  allowMultiplyPriceByUnits: {
    id: "behaviourForm.label.allowMultiplyPriceByUnits",
    defaultMessage:
      "Importe tarifa en step 2 (Si se selecciona más de una unidad de alojamiento se muestra el precio multiplicado por el número de unidades)",
  },
  depositCheckoutTextConfiguration: {
    id: "behaviourForm.label.depositCheckoutTextConfiguration",
    defaultMessage: "Texto para importe pago por adelantado",
  },
  extrasTextConfiguration: {
    id: "behaviourForm.label.extrasTextConfiguration",
    defaultMessage: "Texto para título de extras",
  },
  taxesRateType: {
    id: "behaviourForm.label.taxesRateType",
    defaultMessage: "Loaded Rate Type",
  },
  overrideCurrencyAccordingToLocation: {
    id: "behaviourForm.label.overrideCurrencyAccordingToLocation",
    defaultMessage: "Override Currency According To Location",
  },
});

const RoomSelectionViewTypeMessages: Record<RoomSelectionViewType, Message> = defineMessages({
  [RoomSelectionViewType.LIST]: {
    id: "behaviourForm.enum.RoomSelectionViewType.LIST",
    defaultMessage: RoomSelectionViewType.LIST,
  },
  [RoomSelectionViewType.GRID]: {
    id: "behaviourForm.enum.RoomSelectionViewType.GRID",
    defaultMessage: RoomSelectionViewType.GRID,
  },
  [RoomSelectionViewType.GRID_MOBILE]: {
    id: "behaviourForm.enum.RoomSelectionViewType.GRID_MOBILE",
    defaultMessage: RoomSelectionViewType.GRID_MOBILE,
  },
});

const InventoryGroupingCriteriaMessages: Record<
  InventoryGroupingCriteria,
  Message
> = defineMessages({
  [InventoryGroupingCriteria.NONE]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.NONE",
    defaultMessage: InventoryGroupingCriteria.NONE,
  },
  [InventoryGroupingCriteria.CONFIGURATION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONFIGURATION",
    defaultMessage: InventoryGroupingCriteria.CONFIGURATION,
  },
  [InventoryGroupingCriteria.CONDITION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONDITION",
    defaultMessage: InventoryGroupingCriteria.CONDITION,
  },
  [InventoryGroupingCriteria.MEAL_PLAN]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.MEAL_PLAN",
    defaultMessage: InventoryGroupingCriteria.MEAL_PLAN,
  },
  [InventoryGroupingCriteria.CONFIGURATION_AND_CONDITION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONFIGURATION_AND_CONDITION",
    defaultMessage: InventoryGroupingCriteria.CONFIGURATION_AND_CONDITION,
  },
  [InventoryGroupingCriteria.CONFIGURATION_AND_MEAL_PLAN]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONFIGURATION_AND_MEAL_PLAN",
    defaultMessage: InventoryGroupingCriteria.CONFIGURATION_AND_MEAL_PLAN,
  },
  [InventoryGroupingCriteria.CONDITION_AND_CONFIGURATION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONDITION_AND_CONFIGURATION",
    defaultMessage: InventoryGroupingCriteria.CONDITION_AND_CONFIGURATION,
  },
  [InventoryGroupingCriteria.CONDITION_AND_MEAL_PLAN]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.CONDITION_AND_MEAL_PLAN",
    defaultMessage: InventoryGroupingCriteria.CONDITION_AND_MEAL_PLAN,
  },
  [InventoryGroupingCriteria.MEAL_PLAN_AND_CONFIGURATION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.MEAL_PLAN_AND_CONFIGURATION",
    defaultMessage: InventoryGroupingCriteria.MEAL_PLAN_AND_CONFIGURATION,
  },
  [InventoryGroupingCriteria.MEAL_PLAN_AND_CONDITION]: {
    id: "behaviourForm.enum.InventoryGroupingCriteria.MEAL_PLAN_AND_CONDITION",
    defaultMessage: InventoryGroupingCriteria.MEAL_PLAN_AND_CONDITION,
  },
});

const OccupationAlternativesMessages: Record<OccupationAlternatives, Message> = defineMessages({
  [OccupationAlternatives.HIDE]: {
    id: "behaviourForm.enum.OccupationAlternatives.HIDE",
    defaultMessage: OccupationAlternatives.HIDE,
  },
  [OccupationAlternatives.COLLAPSED]: {
    id: "behaviourForm.enum.OccupationAlternatives.COLLAPSED",
    defaultMessage: OccupationAlternatives.COLLAPSED,
  },
  [OccupationAlternatives.EXPANDED]: {
    id: "behaviourForm.enum.OccupationAlternatives.EXPANDED",
    defaultMessage: OccupationAlternatives.EXPANDED,
  },
  [OccupationAlternatives.NO_AVAILABILITY]: {
    id: "behaviourForm.enum.OccupationAlternatives.NO_AVAILABILITY",
    defaultMessage: OccupationAlternatives.NO_AVAILABILITY,
  },
});

const SplitStayMessages: Record<SplitStay, Message> = defineMessages({
  [SplitStay.NONE]: {
    id: "behaviourForm.enum.SplitStay.NONE",
    defaultMessage: SplitStay.NONE,
  },
  [SplitStay.UNAVAILABLE_ONE_CHEAPER]: {
    id: "behaviourForm.enum.SplitStay.UNAVAILABLE_ONE_CHEAPER",
    defaultMessage: SplitStay.UNAVAILABLE_ONE_CHEAPER,
  },
  [SplitStay.UNAVAILABLE_MANY_CHEAPER]: {
    id: "behaviourForm.enum.SplitStay.UNAVAILABLE_MANY_CHEAPER",
    defaultMessage: SplitStay.UNAVAILABLE_MANY_CHEAPER,
  },
  [SplitStay.AVAILABLE_ONE_CHEAPER]: {
    id: "behaviourForm.enum.SplitStay.AVAILABLE_ONE_CHEAPER",
    defaultMessage: SplitStay.AVAILABLE_ONE_CHEAPER,
  },
  [SplitStay.AVAILABLE_BETTER_ONE_CHEAPER]: {
    id: "behaviourForm.enum.SplitStay.AVAILABLE_BETTER_ONE_CHEAPER",
    defaultMessage: SplitStay.AVAILABLE_BETTER_ONE_CHEAPER,
  },
});

const AccommodationSortingCriteriaMessages: Record<
  AccommodationSortingCriteria,
  Message
> = defineMessages({
  [AccommodationSortingCriteria.ASCENDING]: {
    id: "behaviourForm.enum.AccommodationSortingCriteria.ASCENDING",
    defaultMessage: AccommodationSortingCriteria.ASCENDING,
  },
  [AccommodationSortingCriteria.NO_SORTING]: {
    id: "behaviourForm.enum.AccommodationSortingCriteria.NO_SORTING",
    defaultMessage: AccommodationSortingCriteria.NO_SORTING,
  },
});

const ShowPromoCodeCriteriaMessages: Record<ShowPromoCodeCriteria, Message> = defineMessages({
  [ShowPromoCodeCriteria.SHOW_COLLAPSED]: {
    id: "behaviourForm.enum.ShowPromoCodeCriteria.SHOW_COLLAPSED",
    defaultMessage: ShowPromoCodeCriteria.SHOW_COLLAPSED,
  },
  [ShowPromoCodeCriteria.SHOW_EXPANDED]: {
    id: "behaviourForm.enum.ShowPromoCodeCriteria.SHOW_EXPANDED",
    defaultMessage: ShowPromoCodeCriteria.SHOW_EXPANDED,
  },
  [ShowPromoCodeCriteria.HIDE]: {
    id: "behaviourForm.enum.ShowPromoCodeCriteria.HIDE",
    defaultMessage: ShowPromoCodeCriteria.HIDE,
  },
});

const PriceCalendarMessages: Record<PriceCalendar, Message> = defineMessages({
  [PriceCalendar.SHOW_ALL_PRICES]: {
    id: "behaviourForm.enum.PriceCalendar.SHOW_ALL_PRICES",
    defaultMessage: PriceCalendar.SHOW_ALL_PRICES,
  },
  [PriceCalendar.SHOW_SELECTED_DATE_PRICES]: {
    id: "behaviourForm.enum.PriceCalendar.SHOW_SELECTED_DATE_PRICES",
    defaultMessage: PriceCalendar.SHOW_SELECTED_DATE_PRICES,
  },
  [PriceCalendar.HIDE_ALL_PRICES]: {
    id: "behaviourForm.enum.PriceCalendar.HIDE_ALL_PRICES",
    defaultMessage: PriceCalendar.HIDE_ALL_PRICES,
  },
});

const ShowExtrasConfigurationMessages: Record<ShowExtrasConfiguration, Message> = defineMessages({
  [ShowExtrasConfiguration.HIDE_EXTRAS_BEFORE_CHECKOUT]: {
    id: "behaviourForm.enum.ShowExtrasConfiguration.HIDE_EXTRAS_BEFORE_CHECKOUT",
    defaultMessage: ShowExtrasConfiguration.HIDE_EXTRAS_BEFORE_CHECKOUT,
  },
  [ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT]: {
    id: "behaviourForm.enum.ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT",
    defaultMessage: ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT,
  },
  [ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP]: {
    id: "behaviourForm.enum.ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP",
    defaultMessage: ShowExtrasConfiguration.SHOW_EXTRAS_BEFORE_CHECKOUT_DESKTOP,
  },
});

const PendingAmountTextConfigurationMessages: Record<
  PendingAmountTextConfiguration,
  Message
> = defineMessages({
  [PendingAmountTextConfiguration.PAY_AT_ESTABLISHMENT]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.PAY_AT_ESTABLISHMENT",
    defaultMessage: PendingAmountTextConfiguration.PAY_AT_ESTABLISHMENT,
  },
  [PendingAmountTextConfiguration.PAY_AT_HOTEL]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.PAY_AT_HOTEL",
    defaultMessage: PendingAmountTextConfiguration.PAY_AT_HOTEL,
  },
  [PendingAmountTextConfiguration.PENDING_PAYMENT]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.PENDING_PAYMENT",
    defaultMessage: PendingAmountTextConfiguration.PENDING_PAYMENT,
  },
  [PendingAmountTextConfiguration.PAY_ACCORDING_TO_CONDITIONS]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.PAY_ACCORDING_TO_CONDITIONS",
    defaultMessage: PendingAmountTextConfiguration.PAY_ACCORDING_TO_CONDITIONS,
  },
  [PendingAmountTextConfiguration.AMOUNT_REMAINING]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.AMOUNT_REMAINING",
    defaultMessage: PendingAmountTextConfiguration.AMOUNT_REMAINING,
  },
  [PendingAmountTextConfiguration.NO_TEXT]: {
    id: "behaviourForm.enum.PendingAmountTextConfiguration.NO_TEXT",
    defaultMessage: PendingAmountTextConfiguration.NO_TEXT,
  },
});

const DepositRequiredTextConfigurationMessages: Record<
  DepositRequiredTextConfiguration,
  Message
> = defineMessages({
  [DepositRequiredTextConfiguration.NO_TEXT]: {
    id: "behaviourForm.enum.DepositRequiredTextConfiguration.NO_TEXT",
    defaultMessage: DepositRequiredTextConfiguration.NO_TEXT,
  },
  [DepositRequiredTextConfiguration.DEPOSIT_REQUIRED]: {
    id: "behaviourForm.enum.DepositRequiredTextConfiguration.DEPOSIT_REQUIRED",
    defaultMessage: DepositRequiredTextConfiguration.DEPOSIT_REQUIRED,
  },
  [DepositRequiredTextConfiguration.ADVANCE_PAYMENT]: {
    id: "behaviourForm.enum.DepositRequiredTextConfiguration.ADVANCE_PAYMENT",
    defaultMessage: DepositRequiredTextConfiguration.ADVANCE_PAYMENT,
  },
});

const DepositNotRequiredTextConfigurationMessages: Record<
  DepositNotRequiredTextConfiguration,
  Message
> = defineMessages({
  [DepositNotRequiredTextConfiguration.NO_TEXT]: {
    id: "behaviourForm.enum.DepositNotRequiredTextConfiguration.NO_TEXT",
    defaultMessage: DepositNotRequiredTextConfiguration.NO_TEXT,
  },
  [DepositNotRequiredTextConfiguration.DEPOSIT_NOT_REQUIRED]: {
    id: "behaviourForm.enum.DepositNotRequiredTextConfiguration.DEPOSIT_NOT_REQUIRED",
    defaultMessage: DepositNotRequiredTextConfiguration.DEPOSIT_NOT_REQUIRED,
  },
  [DepositNotRequiredTextConfiguration.NO_ADVANCE_PAYMENT]: {
    id: "behaviourForm.enum.DepositNotRequiredTextConfiguration.NO_ADVANCE_PAYMENT",
    defaultMessage: DepositNotRequiredTextConfiguration.NO_ADVANCE_PAYMENT,
  },
  [DepositNotRequiredTextConfiguration.PAYMENT_AT_ESTABLISHMENT]: {
    id: "behaviourForm.enum.DepositNotRequiredTextConfiguration.PAYMENT_AT_ESTABLISHMENT",
    defaultMessage: DepositNotRequiredTextConfiguration.PAYMENT_AT_ESTABLISHMENT,
  },
});

const TaxesTextMessages: Record<TaxesText, Message> = defineMessages({
  [TaxesText.TAXES_INCLUDED]: {
    id: "behaviourForm.enum.TaxesText.TAXES_INCLUDED",
    defaultMessage: TaxesText.TAXES_INCLUDED,
  },
  [TaxesText.TAXES_EXCLUDED]: {
    id: "behaviourForm.enum.TaxesText.TAXES_EXCLUDED",
    defaultMessage: TaxesText.TAXES_EXCLUDED,
  },
  [TaxesText.TAXES_AND_FEES_INCLUDED]: {
    id: "behaviourForm.enum.TaxesText.TAXES_AND_FEES_INCLUDED",
    defaultMessage: TaxesText.TAXES_AND_FEES_INCLUDED,
  },
  [TaxesText.TAXES_AND_FEES_EXCLUDED]: {
    id: "behaviourForm.enum.TaxesText.TAXES_AND_FEES_EXCLUDED",
    defaultMessage: TaxesText.TAXES_AND_FEES_EXCLUDED,
  },
  [TaxesText.TAXES_INCLUDED_FEES_EXCLUDED]: {
    id: "behaviourForm.enum.TaxesText.TAXES_INCLUDED_FEES_EXCLUDED",
    defaultMessage: TaxesText.TAXES_INCLUDED_FEES_EXCLUDED,
  },
});

const BundlingConfigurationMessages: Record<BundlingConfiguration, Message> = defineMessages({
  [BundlingConfiguration.HIDE]: {
    id: "behaviourForm.enum.BundlingConfiguration.HIDE",
    defaultMessage: BundlingConfiguration.HIDE,
  },
  [BundlingConfiguration.SHOW]: {
    id: "behaviourForm.enum.BundlingConfiguration.SHOW",
    defaultMessage: BundlingConfiguration.SHOW,
  },
  [BundlingConfiguration.SHOW_AVAIL]: {
    id: "behaviourForm.enum.BundlingConfiguration.SHOW_AVAIL",
    defaultMessage: BundlingConfiguration.SHOW_AVAIL,
  },
});

const PromosMessages: Record<PromosConfig, Message> = defineMessages({
  [PromosConfig.SHOW_ALWAYS]: {
    id: "behaviourForm.enum.promos.SHOW_ALWAYS",
    defaultMessage: PromosConfig.SHOW_ALWAYS,
  },
  [PromosConfig.SHOW_WHEN_APPLICABLE]: {
    id: "behaviourForm.enum.promos.SHOW_WHEN_APPLICABLE",
    defaultMessage: PromosConfig.SHOW_WHEN_APPLICABLE,
  },
});

const depositCheckoutTextConfigurationMessages: Record<
  DepositCheckoutTextConfiguration,
  Message
> = defineMessages({
  [DepositCheckoutTextConfiguration.DEPOSIT]: {
    id: "behaviourForm.enum.depositCheckout.DEPOSIT",
    defaultMessage: DepositCheckoutTextConfiguration.DEPOSIT,
  },
  [DepositCheckoutTextConfiguration.PAY_ACCORDING_TO_CONDITIONS]: {
    id: "behaviourForm.enum.depositCheckout.PAY_ACCORDING_TO_CONDITIONS",
    defaultMessage: DepositCheckoutTextConfiguration.PAY_ACCORDING_TO_CONDITIONS,
  },
  [DepositCheckoutTextConfiguration.ADVANCE_PAYMENT]: {
    id: "behaviourForm.enum.depositCheckout.ADVANCE_PAYMENT",
    defaultMessage: DepositCheckoutTextConfiguration.ADVANCE_PAYMENT,
  },
  [DepositCheckoutTextConfiguration.PAY_NOW]: {
    id: "behaviourForm.enum.depositCheckout.PAY_NOW",
    defaultMessage: DepositCheckoutTextConfiguration.PAY_NOW,
  },
});

const extrasTextConfigurationMessages: Record<ExtrasTextConfiguration, Message> = defineMessages({
  [ExtrasTextConfiguration.EXTRAS]: {
    id: "behaviourForm.enum.extrasText.EXTRAS",
    defaultMessage: ExtrasTextConfiguration.EXTRAS,
  },
  [ExtrasTextConfiguration.EXTRA_SERVICES]: {
    id: "behaviourForm.enum.extrasText.EXTRA_SERVICES",
    defaultMessage: ExtrasTextConfiguration.EXTRA_SERVICES,
  },
  [ExtrasTextConfiguration.IMPROVE_STAY]: {
    id: "behaviourForm.enum.extrasText.IMPROVE_STAY",
    defaultMessage: ExtrasTextConfiguration.IMPROVE_STAY,
  },
});

const taxesRateTypeMessages: Record<RateType, Message> = defineMessages({
  [RateType.INCLUDED]: {
    id: "behaviourForm.enum.RateType.INCLUDED",
    defaultMessage: RateType.INCLUDED,
  },
  [RateType.EXCLUDED]: {
    id: "behaviourForm.enum.RateType.EXCLUDED",
    defaultMessage: RateType.EXCLUDED,
  },
});

export const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...formMessages,
  ...PromosMessages,
  ...RoomSelectionViewTypeMessages,
  ...InventoryGroupingCriteriaMessages,
  ...OccupationAlternativesMessages,
  ...SplitStayMessages,
  ...AccommodationSortingCriteriaMessages,
  ...ShowPromoCodeCriteriaMessages,
  ...PriceCalendarMessages,
  ...ShowExtrasConfigurationMessages,
  ...PendingAmountTextConfigurationMessages,
  ...DepositRequiredTextConfigurationMessages,
  ...DepositNotRequiredTextConfigurationMessages,
  ...TaxesTextMessages,
  ...BundlingConfigurationMessages,
  ...depositCheckoutTextConfigurationMessages,
  ...extrasTextConfigurationMessages,
  ...taxesRateTypeMessages,
  ...defineMessages({
    entityName: {
      id: "behaviour.entityName",
      defaultMessage: "Behaviour",
    },
  }),
};
